import { fromJS } from 'immutable';

import * as constants from 'actions/instances/constants';
import uiRecord from 'reducers/ui/records';

export const initialState = uiRecord();

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_INSTANCES_STATUSES:
      return uiRecord({
        loader: true
      });

    case constants.GET_INSTANCES_STATUSES_SUCCESS:
      return uiRecord();

    case constants.GET_INSTANCES_STATUSES_ERROR:
      return uiRecord({
        error: fromJS(action.error)
      });

    default:
      return state;
  }
};
